var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.19,
    height: 14.755,
    viewBox: "0 0 13.19 14.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M.931,36.394a5.594,5.594,0,0,0,2.383,4.584.462.462,0,0,1,.024.742l-.007.005a.46.46,0,0,1-.549.017A6.524,6.524,0,0,1,0,36.394a6.6,6.6,0,0,1,6.55-6.531v.931A5.665,5.665,0,0,0,.931,36.394Zm0,0",
    transform: "translate(0 -29.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M224.907.028l1.711,1.17a.158.158,0,0,1,0,.261l-1.711,1.17a.158.158,0,0,1-.247-.13V.158a.158.158,0,0,1,.247-.13Zm0,0",
    transform: "translate(-218.186 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M236.177,72.483a5.594,5.594,0,0,0-2.383-4.584.462.462,0,0,1-.024-.742l.007-.005a.46.46,0,0,1,.549-.017,6.524,6.524,0,0,1,2.782,5.349,6.593,6.593,0,0,1-6.545,6.531v-.931A5.661,5.661,0,0,0,236.177,72.483Zm0,0",
    transform: "translate(-223.918 -65.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M164.481,422.428l-1.711-1.17a.158.158,0,0,1,0-.261l1.711-1.17a.158.158,0,0,1,.247.13V422.3A.158.158,0,0,1,164.481,422.428Zm0,0",
    transform: "translate(-158.012 -407.701)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.4524fd1680670226b1bec747b35b80ef.svg";
export { ForwardRef as ReactComponent };